/**
 * Pure functions for computing unified timeline bounds across multiple recordings.
 */

export function computeTimelineBounds(recordings) {
  if (!recordings || recordings.length === 0) {
    return { start: 0, end: 0 };
  }
  let start = Infinity;
  let end = -Infinity;
  for (const rec of recordings) {
    if (rec.startTime < start) start = rec.startTime;
    if (rec.endTime > end) end = rec.endTime;
  }
  return { start, end };
}

export function globalToLocalTime(globalTime, recording) {
  if (!recording) return null;
  if (globalTime < recording.startTime || globalTime > recording.endTime) {
    return null;
  }
  return globalTime - recording.startTime;
}

export function activeRecordingsAtTime(recordings, globalTime) {
  if (!recordings) return [];
  return recordings.filter((rec) => globalTime >= rec.startTime && globalTime <= rec.endTime);
}
